var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EEEEEE",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 31.5L24 26.1L29.4 31.5L31.5 29.4L26.1 24L31.5 18.6L29.4 16.5L24 21.9L18.6 16.5L16.5 18.6L21.9 24L16.5 29.4L18.6 31.5ZM24 39C21.925 39 19.975 38.606 18.15 37.818C16.325 37.03 14.7375 35.9615 13.3875 34.6125C12.0375 33.2625 10.969 31.675 10.182 29.85C9.395 28.025 9.001 26.075 9 24C9 21.925 9.394 19.975 10.182 18.15C10.97 16.325 12.0385 14.7375 13.3875 13.3875C14.7375 12.0375 16.325 10.969 18.15 10.182C19.975 9.395 21.925 9.001 24 9C26.075 9 28.025 9.394 29.85 10.182C31.675 10.97 33.2625 12.0385 34.6125 13.3875C35.9625 14.7375 37.0315 16.325 37.8195 18.15C38.6075 19.975 39.001 21.925 39 24C39 26.075 38.606 28.025 37.818 29.85C37.03 31.675 35.9615 33.2625 34.6125 34.6125C33.2625 35.9625 31.675 37.0315 29.85 37.8195C28.025 38.6075 26.075 39.001 24 39Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCross);
export default __webpack_public_path__ + "static/media/modal_cross.bbb86cdb604268b05e1b932bb54571cd.svg";
export { ForwardRef as ReactComponent };